import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Inicio", path: "/" },
  { label: "Menú", path: "/menu" },
  { label: "Dónde Pecar", path: "/contacto" },
  { label: "Nosotros", path: "/nosotros" },
  { label: "Causas Sociales", path: "/causas" },
  { label: "Blog", path: "/blog" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/0ec3dba52746e06034f9e14a4c92941b.jpeg"
            alt="San7o Pecado Logo"
            className="h-12 w-12 rounded-full object-cover"
          />
          <span
            className={`font-bold text-xl tracking-tight transition-colors duration-300 ${
              scrolled ? "text-[#2d1a0e]" : "text-white"
            }`}
            style={{ fontFamily: "Singo" }}
          >
            SAN7O PECADO
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? scrolled
                    ? "text-[#00b4c8]"
                    : "text-[#7ee8f4]"
                  : scrolled
                  ? "text-[#2d1a0e] hover:text-[#00b4c8]"
                  : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Right Icons */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="https://www.facebook.com/san7opecado/"
            target="_blank"
            rel="noopener noreferrer"
            className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
              scrolled
                ? "text-[#2d1a0e] hover:text-[#1877f2]"
                : "text-white hover:text-[#a8c8ff]"
            }`}
          >
            <i className="ri-facebook-line text-xl"></i>
          </a>
          <a
            href="https://www.instagram.com/san7opecado/"
            target="_blank"
            rel="noopener noreferrer"
            className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
              scrolled
                ? "text-[#2d1a0e] hover:text-[#d4607a]"
                : "text-white hover:text-[#f9b8c8]"
            }`}
          >
            <i className="ri-instagram-line text-xl"></i>
          </a>
          <a
            href="https://www.tiktok.com/@san7o.pecado"
            target="_blank"
            rel="noopener noreferrer"
            className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
              scrolled
                ? "text-[#2d1a0e] hover:text-[#2d1a0e]"
                : "text-white hover:text-[#fde68a]"
            }`}
          >
            <i className="ri-tiktok-line text-xl"></i>
          </a>
          <a
            href="https://wa.me/5217291317070"
            target="_blank"
            rel="noopener noreferrer"
            className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
              scrolled
                ? "text-[#2d1a0e] hover:text-[#00b4c8]"
                : "text-white hover:text-[#7ee8f4]"
            }`}
          >
            <i className="ri-whatsapp-line text-xl"></i>
          </a>
          <Link
            to="/menu"
            className="bg-[#00b4c8] text-white text-sm font-semibold px-5 py-2 rounded-full hover:bg-[#0099aa] transition-colors whitespace-nowrap cursor-pointer"
          >
            Ver Menú
          </Link>
        </div>

        {/* Hamburger */}
        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-full cursor-pointer transition-colors ${
            scrolled ? "text-[#2d1a0e]" : "text-white"
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Abrir menú"
        >
          <i className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-[#f5e6d3] px-4 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium py-2 px-3 rounded-lg cursor-pointer transition-colors ${
                location.pathname === link.path
                  ? "bg-[#e0f7fa] text-[#00b4c8]"
                  : "text-[#2d1a0e] hover:bg-[#e0f7fa]"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="https://wa.me/5217291317070"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 bg-[#00b4c8] text-white text-sm font-semibold px-5 py-2 rounded-full text-center cursor-pointer"
          >
            <i className="ri-whatsapp-line mr-2"></i>WhatsApp
          </a>
        </div>
      )}
    </header>
  );
}
